function o(e) {
  if (!e)
    return {};
  const t = new URLSearchParams(e);
  return Array.from(t.keys()).reduce((n, u) => {
    const r = t.getAll(u), a = r.length > 1 ? r : r[0];
    return a ? {
      ...n,
      [u]: a
    } : n;
  }, {});
}
export {
  o as getQueryParams
};
